export const ASADO_BASE_URL =
  process.env.REACT_APP_ASADO_BASE_URL || process.env.GATSBY_APP_ASADO_BASE_URL;
